import React, { useMemo } from "react"
import { Layout } from "antd"
import { Outlet, useLocation } from "react-router-dom"
import { NavigationPath } from "../ProHomeLayout/NavigationPath"
import { useDevice } from "hooks/useDevice"
import styles from "./Index.module.css"
import { useSelector, shallowEqual } from "react-redux"

export const ProBookingsLayout = () => {
  const { isMobile, isTablet } = useDevice()
  const location = useLocation()
  const bookingId = useSelector((store) => store?.bookings?.clientBookingDetails?.data?.booking_id, shallowEqual)

  const bookingsPrefix = "/pro/home/bookings/"

  const computedSubPages = useMemo(() => {
    if (location?.pathname?.startsWith(bookingsPrefix)) {
      const afterBookings = location.pathname.slice(bookingsPrefix.length)
      const id = afterBookings.split("/")[0]
      if (id && id !== "new" && id !== "edit") {
        return [`ID ${bookingId ?? ""}`]
      }
    }
    return []
  }, [location?.pathname, bookingId])

  return (
    <Layout className={styles.layout}>
      {!isMobile && !isTablet && <NavigationPath className="pl-m pr-m " subPages={computedSubPages} />}
      <Outlet />
    </Layout>
  )
}
